"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OldCallbackBannerContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _tracking = require("../../utils/tracking");
var _actionAfterViewedComponent = require("@cian/action-after-viewed-component");
var _uiKit = require("@cian/ui-kit");
var _useConsultingRequest2 = require("../../hooks/useConsultingRequest");
var _OldCallbackBannerDesktop = require("../../components/OldCallbackBannerDesktop");
var _OldCallbackBannerMobile = require("../../components/OldCallbackBannerMobile");
const _excluded = ["success"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const OldCallbackBannerContainer = _ref => {
  let {
    personalAgreementLink,
    defaultPhoneNumber,
    regionId,
    placeType,
    gaLabel,
    userId
  } = _ref;
  const _useConsultingRequest = (0, _useConsultingRequest2.useConsultingRequest)({
      defaultPhoneNumber,
      regionId,
      gaLabel,
      placeType,
      cianRentRefocus: true,
      userId
    }),
    {
      success
    } = _useConsultingRequest,
    bannerProps = (0, _objectWithoutProperties2.default)(_useConsultingRequest, _excluded);
  if (success) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_uiKit.Responsive, {
      desktop: true
    }, /*#__PURE__*/React.createElement(_OldCallbackBannerDesktop.OldCallbackBannerDesktopSuccess, {
      placeType: placeType
    })), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
      tablet: true,
      phone: true
    }, /*#__PURE__*/React.createElement(_OldCallbackBannerMobile.OldCallbackBannerMobileSuccess, null)));
  }
  return /*#__PURE__*/React.createElement(_actionAfterViewedComponent.ActionAfterViewObserver, {
    callback: _tracking.trackCallbackBannerShow,
    percentVisible: 1,
    triggerOnce: true
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    desktop: true
  }, /*#__PURE__*/React.createElement(_OldCallbackBannerDesktop.OldCallbackBannerDesktop, (0, _extends2.default)({
    personalAgreementLink: personalAgreementLink,
    placeType: placeType
  }, bannerProps))), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    tablet: true,
    phone: true
  }, /*#__PURE__*/React.createElement(_OldCallbackBannerMobile.OldCallbackBannerMobile, (0, _extends2.default)({
    personalAgreementLink: personalAgreementLink
  }, bannerProps)))));
};
exports.OldCallbackBannerContainer = OldCallbackBannerContainer;